module.exports = __webpack_public_path__ + "static/rules_for_comprehensive_banking_services_for_individuals_archive-2d0bfc73bd7ff7323607fce3ae5d6067.pdf";